import {
  Maybe,
  VerticalID,
  Operation,
} from '../../../__generated__/globalTypes'

import sendMagicLinkString from '../SendMagicLink.graphql'

export type SendMagicLinkData = {
  sendMagicLink: {
    success: boolean
    message: Maybe<string>
  }
}

export type SendMagicLinkVariables = {
  email: string
  verticalId?: Maybe<VerticalID>
}

export type SendMagicLink = Operation<SendMagicLinkData, SendMagicLinkVariables>

export const SendMagicLink = ({
  email,
  verticalId,
}: SendMagicLinkVariables): SendMagicLink => ({
  query: sendMagicLinkString,
  variables: {
    email,
    verticalId,
  },
})
